/* Import Module */
import $ from "jquery";

/* Define Script */
export const redirectScheduleEdit = (scheduleEditUrl: string) => {
  window.location.href = scheduleEditUrl;
};
